import FavoriteNodeViewState from './schema/FavoriteNodeViewState';
import FavoritesViewState from './schema/FavoritesViewState';
import MailFavoritesStore from './schema/MailFavoritesStore';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

const defaultMailFavoritesViewState: FavoritesViewState = {
    contextMenuState: null,
    shouldShowFindFavoritesPicker: false,
};

const defaultMailFavoritesStore: MailFavoritesStore = {
    mailFavoritesViewState: defaultMailFavoritesViewState,
    favoritePersonasRootFolderId: undefined,
    isFavoritingInProgress: new ObservableMap<string, boolean>({}),
    favoriteNodeViewStates: new ObservableMap<string, FavoriteNodeViewState>({}),
};

export const getStore = createStore<MailFavoritesStore>('mailFavorites', defaultMailFavoritesStore);
export default getStore();
